export const BUILD_ENV = process.env.REACT_APP_USER_BRANCH;

const CHUNK_RELOAD_FLAG = "aivy-pdf-reports:chunk-reload";

const hasAlreadyReloadedForChunkError = () => {
  try {
    return window.sessionStorage.getItem(CHUNK_RELOAD_FLAG) === "1";
  } catch {
    return true; // sessionStorage blockiert -> lieber keinen Reload riskieren
  }
};

const markReloadedForChunkError = () => {
  try {
    window.sessionStorage.setItem(CHUNK_RELOAD_FLAG, "1");
  } catch {
    // sessionStorage blockiert, dann eben ohne Merker
  }
};

/**
 * Fuehrt einen dynamischen `import()` mit Retries aus und laesst als letzten
 * Ausweg die Seite einmal neu laden.
 *
 * pdfGenerator (aivy-backend-app) wartet nur per
 * `page.waitForFunction(() => !!window.pdfurl)` — schlaegt ein Chunk fehl,
 * mountet nie eine der beiden Report-Generationen, window.pdfurl bleibt leer
 * und die Lambda haengt bis zum Timeout, ohne dass irgendwo ein Fehler
 * auftaucht (siehe PdfShell.js). Das deckt zwei unabhaengige Ursachen ab:
 * ein kurzer Netzwerk-Haenger (Retry auf dieselbe URL reicht) und ein Deploy,
 * das den angeforderten Chunk-Hash inzwischen entfernt hat (nur ein frisches
 * index.html mit neuer Chunk-Map hilft dort — deshalb der Reload, per
 * sessionStorage auf einen Versuch pro Tab begrenzt).
 */
export const loadChunk = (importFn, retries = 2, delayMs = 500) =>
  importFn().catch((error) => {
    if (retries > 0) {
      return new Promise((resolve) => setTimeout(resolve, delayMs)).then(() =>
        loadChunk(importFn, retries - 1, delayMs * 2),
      );
    }

    if (!hasAlreadyReloadedForChunkError()) {
      markReloadedForChunkError();
      window.location.reload();

      return new Promise(() => {}); // Seite laedt ohnehin neu
    }

    throw error;
  });

export const isNetworkError = ({ message }) => {
  return (
    message.toLowerCase().includes("failed to fetch") ||
    message.toLowerCase().includes("network error") ||
    message.toLowerCase().includes("networkerror") ||
    message.toLowerCase().includes("no current user") ||
    message.toLowerCase().includes("load failed") ||
    message.toLowerCase().includes("timeout exceeded")
  );
};

/* Outlooks Safe-Links-Scanner oeffnet Report-Links aus Mails in einem
   Headless-Chrome und verwirft dabei eigene Promises mit diesem String.
   Das ist kein Fehler der App, sondern Rauschen in Bugsnag. */
const LINK_SCANNER_REJECTION =
  /^Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+$/;

export const isLinkScannerRejection = (nonErrorParameter) =>
  typeof nonErrorParameter === "string" &&
  LINK_SCANNER_REJECTION.test(nonErrorParameter);

export const PDF_TYPES = {
  REQUIREMENT_PROFILE: "REQUIREMENTPROFILE",
  MATCHING_PROFILE: "MATCHINGPROFILE",
  TALENT_PROFILE: "TALENTPROFILE",
  TEAM_PROFILE: "TEAMPROFILE",
};
